import { useState, useEffect } from "react";
import { connect } from "react-redux";
import TaxHarvestingCard from "./TaxHarvestingCard";

function TaxHarvestingCards(props) {
  const [cards, setCards] = useState([]);

  useEffect(() => {
    if(!props.snapshot && !props.snapshot.length) return;
    prepareCards(props.snapshot?.summary?.presentation?.cards);
  }, [props.snapshot])

  const prepareCards = (snapshotCards) => {
    const cards = Object.values(snapshotCards)
    if (!cards.length) return;
    setCards(Object.values(cards))
  }

  return (
    <div className="c-tax-harvesting-cards">
      <div className="c-tax-harvesting-cards__row">
        {cards.length > 0 && cards.map((card, cardIndex) => {
          return (<TaxHarvestingCard key={cardIndex} {...card} />)
        })}
      </div>
    </div>
  );
}


export default TaxHarvestingCards;
